import React, { useState } from "react";
import axios from "../../utils/axiosConfig";
import { useLookup } from "../../utils/useLookup";
import { formatReportDate } from "../../utils/reportDate";

const CopyDocPendingReport = () => {
  const { suppliers: shippers } = useLookup();
  const [shipperId, setShipperId] = useState("");
  const [rows, setRows] = useState([]);
  const [generated, setGenerated] = useState(false);

  const fmt = formatReportDate;

  const handleGenerate = async () => {
    try {
      const body = {};
      if (shipperId) body.shipperId = Number(shipperId);
      const res = await axios.post("/newdeal/report/copy-doc-pending", body);
      setRows(res.data);
      setGenerated(true);
    } catch { alert("Failed to generate report."); }
  };

  return (
    <div className="container-fluid mt-3">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white">
          <span className="badge bg-success fs-6 px-3 py-2">Copy Document Pending Report</span>
        </div>
        <div className="card-body">
          <div className="row g-3 mb-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label">Select Supplier</label>
              <select className="form-select form-select-sm" value={shipperId} onChange={e => setShipperId(e.target.value)}>
                <option value="">All Supplier</option>
                {shippers.map(s => <option key={s.ShipperID} value={s.ShipperID}>{s.ShipperName}</option>)}
              </select>
            </div>
            <div className="col-md-2">
              <button className="btn btn-success btn-sm" onClick={handleGenerate}>Generate Report</button>
            </div>
          </div>

          {generated && (
            <>
              <div className="mb-2 text-muted" style={{ fontSize: "13px" }}>Total Records: {rows.length}</div>
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered table-hover table-sm" style={{ fontSize: "13px" }}>
                  <thead className="table-success">
                    <tr>
                      <th>#</th><th>Deal ID</th><th>Deal Date</th><th>Buyer</th><th>Shipper</th>
                      <th>Total Qty</th><th>Containers</th><th>BL No</th><th>BL Date</th><th>Invoice No</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length === 0
                      ? <tr><td colSpan={10} className="text-center text-muted py-3">No records found.</td></tr>
                      : rows.map((r, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td><td>{r.DealID}</td><td>{fmt(r.DealDate)}</td>
                          <td>{r.BuyerName || "-"}</td><td>{r.ShipperName || "-"}</td>
                          <td>{r.TotalQty ?? "-"}</td><td>{r.NoOfContainer ?? "-"}</td>
                          <td>{r.BLNo || "-"}</td><td>{fmt(r.BLDate)}</td><td>{r.InvoiceNo || "-"}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CopyDocPendingReport;
